import { Viewports } from "../../store/enums";
import HashCheckToScroll from "../helper/hash-check-to-scroll";

class OptionGrid {
    constructor(DOMelement, store) {
        try {
            this.el = DOMelement;
            this.store = store;
            this.optionList = this.el.querySelector(".sd-option-list__select");
            this.optionGrid = this.el.querySelector(".sd-option-grid");
            this.container = document.querySelectorAll(".best-time-to-visit__climate");
            this.content = this.optionGrid.querySelector(".sd-option-grid__content");
            this.dataRows = this.content.querySelectorAll(".sd-option-grid-row");

            this.optionList.addEventListener("change", (e) => this.onValueChange(e.target.value));

            this.viewPort = this.store.getState().viewport;
            this.store.subscribeValue("viewport", this.onViewportChange.bind(this));

            // Init component
            this.onViewportChange(this.viewPort);

            if (this.container && this.content.childElementCount == 0) {
                this.container[0].style.display = "none";
            }

            //grab a hash if there is one (this is for auto-scrolling when being redirected eg. #tours or #best-time-to-visit)
            const hash = new URL(data.currenturl).hash;
            if (hash) {
                new HashCheckToScroll(hash);
            }

        } catch (error) {
            console.log(error);
        }
    }

    onValueChange(value) {
        this.dataRows.forEach((row) => {
            const attr = row.getAttribute("data-location");
            row.style.display = value === attr ? "flex" : "none";
        });
    }

    onViewportChange(viewPort) {
        if (viewPort === Viewports.Mobile) {
            this.onValueChange(this.optionList.value);
        } else {
            this.dataRows.forEach((row) => {
                row.style.display = "flex";
            });
        }
    }
}

export default OptionGrid;